import { z } from 'zod';
export const idSchema = z.uuid();
/** Date-time fields are transported as ISO 8601 strings, never as Date objects. */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });
/** Calendar dates (release date, purchase date) are transported as YYYY-MM-DD. */
export const isoDateSchema = z.iso.date();
/**
 * Fields the user edited by hand. `applyExternalData` in the API refuses to
 * touch any field listed here, which is what keeps an API refresh from
 * clobbering manual corrections.
 */
export const manualOverridesSchema = z.array(z.string()).default([]);
/** Per-field bookkeeping: which source delivered it and when. */
export const fieldProvenanceSchema = z.record(z.string(), z.object({ source: z.string(), fetchedAt: isoDateTimeSchema }));
export const sortOrderSchema = z.enum(['asc', 'desc']).default('asc');
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(50),
});
/** Wraps a row schema into the envelope every list endpoint returns. */
export function paginated(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int().nonnegative(),
        page: z.number().int().min(1),
        perPage: z.number().int().min(1),
    });
}
export const errorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
export const okResponseSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=common.js.map